import { render, staticRenderFns } from "./connection-teamtailor.vue?vue&type=template&id=81b37894&scoped=true&"
import script from "./connection-teamtailor.ts?vue&type=script&lang=ts&"
export * from "./connection-teamtailor.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b37894",
  null
  
)

export default component.exports